import React from "react";
import { useProductOutput, useIsProductLoading } from "stores/product";
import { OrderCodePart } from "./components/OrderCodePart";
import { useTranslate } from "hooks";

export const OrderCodeForm = ({ isModal = false }: { isModal?: boolean }) => {
  const translate = useTranslate();
  const output = useProductOutput();
  const isLoading = useIsProductLoading();
  const parts = output?.product?.orderCode?.parts;

  if ((!parts || parts.length === 0) && !isLoading) {
    return <div>{translate("PRODUCT_ORDERCODE_NO_PARTS")}</div>;
  }
  return parts
    ?.filter(
      (part) =>
        part &&
        part.state !== null &&
        (part.state < 2 || (part.state === 3 && part.presentation)),
    )
    .map((part) => {
      return <OrderCodePart key={part.key} part={part} isModal={isModal} />;
    });
};
